import { useSnapshots } from 'app/agriculture/queries/snapshots/useSnapshots';
import { useHerds } from 'app/agriculture/queries/herds/useHerds';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { useMemo } from 'react';
import Fuse from 'fuse.js';

export function useHerdResults(textFilter: string) {
    const snapshots = useSnapshots({ snapshotType: 'Herd', shelfLife: null });
    const herds = useHerds();
    const paddocks = useEntities('Paddock');

    const fuse = useMemo(
        () =>
            new Fuse(Array.from(herds.values()), {
                keys: [
                    { name: 'name', weight: 1 },
                    { name: 'animalSpecies', weight: 0.6 },
                    { name: 'herdType', weight: 0.6 },
                    {
                        name: 'snapshot.location.name',
                        weight: 0.6,
                        getFn: ({ id }) => {
                            const snapshot = snapshots.get(id);
                            if (!snapshot) return '';
                            const { paddockId } = snapshot;
                            if (paddockId == null) return 'offsite';
                            return paddocks.get(paddockId)?.name ?? '';
                        },
                    },
                    {
                        name: 'snapshot.totalAnimals',
                        weight: 0.2,
                        getFn: ({ id }) => snapshots.get(id)?.totalAnimals.toString() ?? '0',
                    },
                ],
            }),
        [herds, paddocks, snapshots],
    );

    return useMemo(
        () =>
            !textFilter
                ? Array.from(herds.values())
                : fuse.search(textFilter).map(({ item }) => item),
        [textFilter, fuse, herds],
    );
}
